<template>
  <div>
    <b-table
      class="position-relative"
      :items="resolvedList"
      responsive
      :fields="cols"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
    >
      <template #cell(created_at)="data">
        {{ data.item.created_at | formatDate }}
      </template>
    </b-table>
  </div>
</template>

<script>
import {
  BTable,
} from 'bootstrap-vue'
import {
  computed,
} from '@vue/composition-api'
import store from '@/store'

export default {
  components: {
    BTable,
  },
  props: {
    tableColumns: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const cols = computed(() => [...props.tableColumns, 'resolved_by'])
    const resolvedList = computed(() => store.getters['driverView/getResolvedInactivations'])
    return {
      cols,
      resolvedList,
    }
  },
}
</script>

<style>

</style>
